export const READ_ONLY_TOKEN_SESSION_STORAGE_KEY = 'readOnlyToken'


// WEBPACK FOOTER //
// ./src/constants/sessionStorage.js